import { ModeToggle } from '@/components/ui/mode-toggle'
import { UserDropdown } from '@/components/ui/user-dropdown'
import { HeaderBranding } from '@/components/ui/header-branding'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { Badge } from '@/components/ui/badge'
import { useAuth } from '@/contexts/AuthContext'
import { useUserPlan } from '@/contexts/UserPlanContext'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { LogIn, Sparkles } from 'lucide-react'

export const AppHeader = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { isAuthenticated, isLoading } = useAuth()
  const {
    isFreePlan,
    planDisplayName,
    isLoading: isPlanLoading,
  } = useUserPlan()
  const isHistoryRoute = location.pathname === '/history'
  const isUploadRoute = location.pathname === '/'

  return (
    <header
      className="fixed top-0 left-0 z-50 h-14 w-full border-b border-border bg-background/90 backdrop-blur-md"
    >
      <div className="mx-auto flex h-14 w-full max-w-[1600px] items-center gap-4 px-4">
        <div className="shrink-0">
          <HeaderBranding />
        </div>
        {isLoading || (isAuthenticated && isPlanLoading) ? (
          <Skeleton className="hidden h-6 w-20 rounded-full sm:inline-flex" />
        ) : (
          <>
            <Badge
              variant="secondary"
              className="hidden rounded-full border-border bg-secondary px-2.5 py-0.5 text-[11px] font-semibold text-muted-foreground sm:inline-flex"
            >
              {isAuthenticated ? planDisplayName || 'Free' : 'Free'}
            </Badge>
            {isAuthenticated && isFreePlan && (
              <Button
                asChild
                variant="outline"
                size="sm"
                className="hidden h-8 cursor-pointer border-border bg-background/40 py-1.5 md:inline-flex"
              >
                <Link to="/pricing" className="flex items-center gap-2">
                  <Sparkles className="h-4 w-4 fill-primary text-primary" />
                  <span className="text-sm font-medium leading-tight">
                    Upgrade Plan
                  </span>
                </Link>
              </Button>
            )}
          </>
        )}
        <div className="ml-auto flex items-center gap-2">
          {isAuthenticated && (
            <Button
              variant={isHistoryRoute ? 'secondary' : 'ghost'}
              size="sm"
              className="h-8 text-xs"
              onClick={() => navigate('/history')}
            >
              History
            </Button>
          )}
          {isAuthenticated && (
            <Button
              variant={isUploadRoute ? 'secondary' : 'default'}
              size="sm"
              className="h-8 text-xs"
              onClick={() => navigate('/')}
            >
              Upload
            </Button>
          )}
          <ModeToggle />
          <div className="flex items-center gap-2">
            {isLoading ? (
              <Skeleton className="h-9 w-24 rounded-md" />
            ) : isAuthenticated ? (
              <>
                <UserDropdown />
              </>
            ) : (
              <Button
                asChild
                variant="default"
                size="sm"
                className="h-8 cursor-pointer"
              >
                <Link to="/auth/signin">
                  <LogIn className="h-4 w-4 mr-2" />
                  Sign In
                </Link>
              </Button>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}
